import * as NoticeActionTypes from '../../../constants/contents/NoticeActionTypes';

const initialState = {
    searchKeyword: '',
    searchType: 'title',
};

export default (state = initialState, action) => {
    switch (action.type) {
        case NoticeActionTypes.CLEAR_ITEMS:
            return {
                searchKeyword: '',
                searchType: 'title',
            };
        case NoticeActionTypes.SEARCH_KEYWORD:
            return Object.assign({}, state, {
                searchKeyword: action.searchKeyword,
                searchType: action.searchType,
            });
        default :
            return state;
    }
}
